import { Component, OnInit, Output } from '@angular/core';
import { Sponsor } from '@app/_models/giveaway';
import { GiveawayService } from '@app/services/giveaways/giveaways.service';
import { EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import Utilities from '@app/_helpers/utilities';


@Component({
  selector: 'giveaway-new-sponsor',
  templateUrl: './add-sponsor.component.html',
  styleUrls: ['./add-sponsor.component.scss']
})
export class AddSponsorComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private giveawayService: GiveawayService,
    private builder: FormBuilder,
  ) { }
  @Output() onAddedSponsors: EventEmitter<Sponsor[]> = new EventEmitter();
  isSponsorListhidden: boolean = false;
  sponsors: Sponsor[] = [];
  selectedSponsors: Sponsor[] = [];
  newSponsorImgReview: string;
  newSponsorForm = this.builder.group({
    name: ['', Validators.required],
    image: ['', Validators.required],
  });


  ngOnInit() {
    this.giveawayService.getSponsors().subscribe((res: Sponsor[]) => {
      this.sponsors = res;
    });
  }

  async handleFileInput(image: File) {
    this.newSponsorImgReview = await Utilities.toBase64(image);
    this.newSponsorForm.patchValue({
      image: image,
    });
  }

  uploadNewSponsorImage() {
    document.getElementById('fileInput').click();
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  showNewSponsor() {
    this.isSponsorListhidden = true;
  }
  saveNewSponsor(action) {
    if (action) {
      const newSponsor = new FormData();
      newSponsor.append('name', this.newSponsorForm.value.name);
      newSponsor.append('image', this.newSponsorForm.value.image);
      this.giveawayService.createSponsor(newSponsor).subscribe((res: Sponsor) => {
        this.sponsors.push(res);
        this.newSponsorForm.reset();
        this.newSponsorImgReview = '';
        this.isSponsorListhidden = false;
      }, (err) => {
        debugger;
      });
    }
  }

  addNewSponsorsToGiveaway() {
    this.onAddedSponsors.emit(this.selectedSponsors);
    this.dialog.closeAll();
  }

  selectSponsor(sponsor: Sponsor, target: Element) {
    if (target.classList.contains('active')) {
      target.classList.remove('active');
      this.selectedSponsors = this.selectedSponsors.filter((e) => {
        e.id !== sponsor.id;
      });
    } else {
      target.classList.add('active');
      this.selectedSponsors.push(sponsor);
    }
  }
}
